import React, { useState, useEffect } from "react";
import Button from "./button";
import Deco from "./Deco";

const PHRASES = [
  "pay for itself",
  "pull its weight",
  "earn its keep",
];

const TYPE_MS = 80;
const PAUSE_MS = 2200;
const MOBILE_BREAKPOINT = 900;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const Header = () => {
  const isMobile = useIsMobile();
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  const phrase = PHRASES[phraseIndex];
  const displayed = phrase.slice(0, charIndex);

  const scrollToFeaturedWork = () => {
    const el = document.getElementById("featured-work");
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top, behavior: "smooth" });
      return;
    }
    window.location.href = "/work";
  };

  useEffect(() => {
    if (isMobile) return;

    if (charIndex < phrase.length) {
      const t = setTimeout(() => setCharIndex((c) => c + 1), TYPE_MS);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setPhraseIndex((i) => (i + 1) % PHRASES.length);
      setCharIndex(0);
    }, PAUSE_MS);
    return () => clearTimeout(t);
  }, [charIndex, phrase.length, isMobile]);

  return (
    <div className="header-body">
      <Deco name="one" className="hero-deco hero-deco--one" />
      <Deco name="two" className="hero-deco hero-deco--two" />
      <Deco name="four" className="hero-deco hero-deco--four" />
      <Deco name="five" className="hero-deco hero-deco--five" />
      <Deco name="eight" className="hero-deco hero-deco--six" />
      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <h1 className="hero-title">
          Your next website should{" "}<br/>
          <span className="hero-title__accent">
            {isMobile ? "pay for itself" : displayed}
          </span>
          {isMobile ? "." : "."}
        </h1>
        <p className="hero-lead m-auto pb-3">
          We help growing businesses show up with a brand & website that feels
          cohesive, modern, and intentional.
        </p>
        <Button onClick={scrollToFeaturedWork}>See our work</Button>
      </div>
    </div>
  );
};

export default Header;
